import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TokenGuard } from "../App";
import { StandardURL } from "../App";


const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

  .auth-page {
    min-height: 100vh;
    background: #0f172a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Inter', sans-serif;
    padding: 2rem 1rem;
    position: relative;
    overflow: hidden;
  }

  .auth-page::before {
    content: '';
    position: absolute;
    top: -10%;
    left: 50%;
    transform: translateX(-50%);
    width: 80vw;
    height: 80vh;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }

  .auth-card {
    position: relative;
    z-index: 1;
    background: #1e293b;
    border: 1px solid #334155;
    border-radius: 16px;
    padding: 3rem 2.5rem;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05) inset;
    text-align: center;
  }

  .auth-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #f8fafc;
    margin-bottom: 1rem;
    letter-spacing: -0.02em;
  }

  .auth-subtitle {
    color: #94a3b8;
    font-size: 0.95rem;
    margin-bottom: 2.5rem;
    line-height: 1.5;
  }

  .btn-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }

  .auth-btn {
    flex: 1;
    border: none;
    border-radius: 8px;
    padding: 0.85rem 1rem;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }

  .auth-btn.danger {
    background: #ef4444;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
  }
  .auth-btn.danger:hover {
    background: #dc2626;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(239, 68, 68, 0.35);
  }

  .auth-btn.secondary {
    background: #334155;
    color: #f8fafc;
  }
  .auth-btn.secondary:hover {
    background: #475569;
    transform: translateY(-1px);
  }
`;

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
    `${StandardURL}/auth/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Logout successful!");
      navigate("/");
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  };

  const handleNo = () => {
    navigate("/landlord/home");
  };

  return (
    <TokenGuard>
      <style>{styles}</style>
      <div className="auth-page">
        <div className="auth-card">
          <h2 className="auth-title">Sign Out</h2>
          <p className="auth-subtitle">Are you sure you want to log out of Multiphasic Infraconstruct?</p>
          
          <div className="btn-group">
            <button onClick={handleNo} className="auth-btn secondary">
              Cancel
            </button>
            <button onClick={handleLogout} className="auth-btn danger">
              Yes, Log out
            </button>
          </div>
        </div>
      </div>
    </TokenGuard>
  );
};

export default Logout;